import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';
import type { ComplimentFrequency } from '../../types';

const OPTIONS: { value: ComplimentFrequency; label: string }[] = [
  { value: 'never', label: 'Never' },
  { value: 'rarely', label: 'Rarely' },
  { value: 'sometimes', label: 'Sometimes' },
  { value: 'often', label: 'Often' },
  { value: 'very_often', label: 'Very often' },
];

export function ComplimentsScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (frequency: ComplimentFrequency) => {
    updateOnboarding({ complimentFrequency: frequency });
  };

  const handleContinue = () => {
    if (onboarding.complimentFrequency) {
      nextStep();
      navigate('/onboarding/week1');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={11} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">
          How often do you receive compliments on your looks?
        </h1>
        <p className="text-secondary mb-8">From friends, family, or strangers.</p>

        <div className="space-y-3 mb-8">
          {OPTIONS.map(({ value, label }) => (
            <OptionCard
              key={value}
              selected={onboarding.complimentFrequency === value}
              onClick={() => handleSelect(value)}
            >
              <OptionCardContent title={label} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button
        onClick={handleContinue}
        disabled={!onboarding.complimentFrequency}
      >
        Continue
      </Button>
    </div>
  );
}
